import { defineComponent as _defineComponent } from 'vue'
import { checkUserPermissions } from '@/auth/user_function'
import { translateLang } from '@/data/i18n/translateLang'
import { computed, withDefaults } from 'vue'

// 定义props、emit
interface Props {
  block?: boolean
  show?: boolean
  title?: string
  iconType?: string
  iconTheme?: 'filled' | 'outlined' | 'twoTone'
  iconClass?: string
  iconStyle?: Record<string, string | number>
  permissionKeys?: string[]
  isOverseasPass?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'g-paid-feature',
  props: {
    block: { type: Boolean, default: false },
    show: { type: Boolean, default: true },
    title: { default: '' },
    iconType: { default: 'crown' },
    iconTheme: { default: 'filled' },
    iconClass: { default: '' },
    iconStyle: { default: () => ({}) },
    permissionKeys: { default: () => [] },
    isOverseasPass: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { block: boolean, show: boolean, title: string, iconType: string, iconTheme: 'filled' | 'outlined' | 'twoTone', iconClass: string, iconStyle: Record<string, string | number>, permissionKeys: string[], isOverseasPass: boolean }



// 计算属性
const computedTitle = computed(() => {
  if (props.title) {
    return props.title
  }
  return hasPermission.value
    ? translateLang('专属功能')
    : translateLang('该功能为付费功能，请联系销售开通后使用~')
})

const hasPermission = computed(() => {
  if (props.isOverseasPass) {
    return true
  }
  if (!props.permissionKeys.length) {
    return false
  }
  return checkUserPermissions(props.permissionKeys) === true
})

return { __sfc: true,props, computedTitle, hasPermission }
}

})